import { FrontSide } from 'three';
import { Sphere } from '@react-three/drei';

const OrbMaterial = function() {
  return (
    <meshPhysicalMaterial
      roughness={ 0.1 }
      ior={ 1.1 }
      reflectivity={ 0.8 }
      specularIntensity={ 1 }
      transparent={ true }
      thickness={ 1.1 }
      transmission={ 0 }
      emissive={ [10, 9, 8] }
      side={ FrontSide }

      attach="material"
    />
  );
};

export default function Orb() {
  return (
    <Sphere
      args={ [0.1] }
      position={ [0, -77, 0] }
    >
      <OrbMaterial />
      <pointLight
        color={ 0xff9966 }
        intensity={ 15 }
        distance={ 5 }
        decay={ 2 }
      />
    </Sphere>
  );
};